﻿export const getDataTestId = (value, placeholder) => {
  if (value) return value;

  let dataTestId = "auto-complete-input-select";

  if (placeholder) dataTestId += `-${placeholder}`;

  return dataTestId;
};
